<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-card grid-list-md>
      <ModelTitle title="Edit Grade" @close="close()" />
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-text-field outlined autofocus type="number" :hide-details="ObtainedMarksErrors.length === 0" dense :error-messages="ObtainedMarksErrors"
              v-model="Grade.ObtainedMarks" label="Obtained Marks"></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secondary" text @click="close()">Close</v-btn>
        <v-btn color="accent" :loading="loading" dark @click="submit()"
          >Update</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import gradeService from "../service.js";

const { validationMixin } = require("vuelidate");
const { required } = require("vuelidate/lib/validators");

export default{
  props: {
    editDialog: {
      default: false,
    },
    editGrade: {
      type: Object,
    },
  },
  name: "update-grade",
  data() {
    return {
      loading: false,
      dialog: false,
      Grade: {
        ObtainedMarks: null
      },
    };
  },
  mixins: [validationMixin],
  validations: {
    Grade: {
      ObtainedMarks: {
        required,
      },
    },
  },
  computed: {
    ObtainedMarksErrors() {
      const errors = [];
      if (!this.$v.Grade.ObtainedMarks.$dirty) return errors;
      if (!this.$v.Grade.ObtainedMarks.required)
        errors.push(this.$t("validations.fieldIsRequired"));

      return errors;
    },
  },
  watch: {
    editDialog(val) {
      this.Grade = JSON.parse(JSON.stringify(this.editGrade));
      this.dialog = val;
    },
  },
  methods: {
    close() {
      this.empty();
      this.$emit("close");
    },
    empty() {
      this.Grade = {
        ObtainedMarks: null,
      };
      this.$v.$reset();
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: this.$t("toastMessage.text.invalidFields"),
          });
      } else {
        this.loading = true;
        return gradeService
          .update(this.Grade.id, this.Grade)
          .then((result) => {
            if (result.status) {
              this.$swal
                .mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000,
                })
                .fire({
                  icon: "success",
                  title: "Grade is updated",
                });
              this.loading = false;
              this.$emit("submit");
              this.close();
            }
          })
          .catch((err) => {
            this.loading = false;
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                icon: "error",
                title: err.data.message,
              });
          });
      }
    },
  },
}
</script>
